import {connect} from 'react-redux';
import DashboardLoader, {DashboardLoaderProps} from './DashboardLoader';
import Action from '../../redux/Actions';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import {RouteComponentProps, withRouter} from 'react-router';

const mapStateToProps = (state: ReduxState, ownProps: RouteComponentProps): Partial<DashboardLoaderProps> => {
   return {
      ...ownProps,
      pageIsLoading: state.pageIsLoading,
      sortMetric: state.reviewsSortMetric,
      reviews: state.reviews,
      totalReviewsCount: state.totalReviewsCount,
      totalOwnedReviewsCount: state.totalOwnedReviewsCount,
      totalNotOwnedReviewsCount: state.totalNotOwnedReviewsCount,
      filteredReviews: state.filteredReviews,
      searchText: state.reviewSearchText
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<DashboardLoaderProps> => {
   return {
      setPageIsLoading: (isLoading: boolean) => {
         dispatch(Action.setPageIsLoading(isLoading));
      },
      setDashboardFilter: filter => {
         dispatch(Action.setDashboardFilter(filter));
      },
      resetReviews: () => {
         dispatch(Action.resetReviews());
      },
      setSearchText: (searchText: string) => {
         dispatch(Action.setReviewSearchText(searchText));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardLoader));
